export const MAIN_ROUTE = '/';
export const ACCOUNT_ROUTE = '/account';
export const PEOPLE_ROUTE = '/people';